<template>
  <div class="mx-auto my-4 v-image__image--cover d-flex justify-center align-center flex-column" :style="{
    backgroundImage:`url('${img}')`,
    width:'100%',
    height:'540px'

  }">
    <h2 class="font-weight-bold primary--text" dir="auto">{{title}}</h2>
    <div style="width: 90%;text-align: justify;" v-html="content"/>
  </div>

</template>

<script>
export default {
  name: "AboutCart",
  props:{
    title:String,
    content:String,
    img:String,
  }
}
</script>

<style scoped>
.about-box {
  width: 80%;
  height: 500px;
  margin: 100px auto;
  padding: 100px 20px 100px 100px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  background-color: white;
  -webkit-clip-path: polygon(0 10%, 100% 0%, 100% 90%, 0% 100%);
  clip-path: polygon(0 10%, 100% 0%, 100% 90%, 0% 100%);
}
</style>